import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Grid} from '@mui/material';
import ListItemSimple from '../card/listItem/listItemSimple';

const hintData = [
    {
        icon: <InfoOutlinedIcon sx={{fontSize: '1.5rem', color: 'gray'}} />,
        link: 'https://kamanlend.ir/help',
        title: 'راهنمای دریافت تسهیلات',
    },
    {
        icon: <InfoOutlinedIcon sx={{fontSize: '1.5rem', color: 'gray'}} />,
        link: 'https://kamanlend.ir',
        title: 'معرفی کمان لند',
    },
];

export default function InformationAndGuideLinkSection({
    height,
}: {
    height?: string;
}) {
    return (
        <Grid container spacing={1}>
            {hintData.map((item, index) => (
                <Grid
                    item
                    xs={12}
                    key={index}
                    sx={{height: 'fit-content', paddingTop: '0px !important'}}
                >
                    <ListItemSimple
                        title={item.title}
                        icon={item.icon}
                        onClick={() => window.open(item.link, '_blank')}
                        id={index}
                        containerStyle={{
                            background: 'var(--input-bg-color) !important',
                            borderRadius: '8px !important',
                            border: '1px solid var(--border-color) !important',
                            marginTop: '10px !important',
                        }}
                        color="!text-[var(--primary-text-color)]"
                    />
                </Grid>
            ))}
        </Grid>
    );
}
